//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MediaPresenter',
  props: {
    content: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    current: null,
  }),
  created() {
    this.addPlaceholders();
    this.current = this.content[0];
  },
  computed: {
    thumbnailLabel() {
      return (thumbnail) => `${thumbnail.name} Thumbnail`;
    },
  },
  methods: {
    onThumbnailClick(thumbnail) {
      if (thumbnail.img_url) {
        this.current = thumbnail;
      }
    },
    addPlaceholders() {
      for (let i = this.content.length; i < 4; i += 1) {
        this.content.push({});
      }
    },
    imageUrl(imageObj) {
      return imageObj.img_url;
    },
    getBackgroundImg(current) {
      return { backgroundImage: `url("${this.imageUrl(current)}")` };
    },
  },
};
